import React, { useContext, useState } from "react";
import { PopupContext, TableContext } from "../index";
import { CardTypes } from "./UserCardService";
import { showSuccessToast } from "../validation/ToastContainer";
import { deleteUser } from "./authService";
import { getDeletePopup } from "../view/popup/PopupContainer";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { MoreVertical, Edit2, Trash2 } from 'lucide-react';

function UsersTableRow({ data, index }) {

    const { config, setConfig } = useContext(TableContext);
    const { setPopup } = useContext(PopupContext);

    // MUI Menu state
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onEditClick = () => {
        handleClose();
        config.showModal({ cardType: CardTypes.EDIT, userId: data.id });
    };

    const onDeleteClick = () => {
        handleClose();

        setPopup(getDeletePopup(`Are you sure you want to delete the ${data.firstName} ${data.lastName}?`, "Delete user", () => {
            deleteUser(data.id).then(() => {
                showSuccessToast("User deleted", "Delete user");
                setConfig({ ...config, lastUpdated: Date.now() });
            })
        }, undefined, "Delete user"));

    };

    const groupNames = (data.groups || [])
        .map((group) => group?.name || group?.groupName || "")
        .filter(Boolean);
    const isAdminRole = String(data.userRole?.name || "").toLowerCase() === "admin";

    return (
        <tr key={index}>
            <td>{data.username}</td>
            <td>{data.firstName}</td>
            <td>{data.lastName}</td>
            <td>{data.type}</td>
            <td>{data.userRole?.name}</td>
            <td className="oct_cell-groups">
                {isAdminRole ? (
                    <span className="oct_cell-groups-empty">All groups selected</span>
                ) : groupNames.length > 0 ? (
                    <div className="oct_cell-groups-list">
                        {groupNames.map((groupName, groupIndex) => (
                            <span className="oct_cell-group-pill" key={`${groupName}-${groupIndex}`}>
                                {groupName}
                            </span>
                        ))}
                    </div>
                ) : (
                    <span className="oct_cell-groups-empty">No group selected</span>
                )}
            </td>
            <td>
                <button className="oct_dropdown-trigger-v2" onClick={handleClick}>
                    <MoreVertical className="oct_icon" />
                </button>

                <Menu
                    className="oct_menu-v2"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}>

                    <MenuItem className="oct_menu-item-v2" onClick={onEditClick}>
                        <Edit2 className="oct_icon" /> Edit
                    </MenuItem>
                    <MenuItem className="oct_menu-item-v2 oct_menu-item-danger" onClick={onDeleteClick}>
                        <Trash2 className="oct_icon" /> Delete
                    </MenuItem>

                </Menu>
            </td>
        </tr>
    );

}

export default UsersTableRow;
